import React, { useState } from 'react';
import Avatar from './Avatar.jsx';
import PersonLink from './PersonLink.jsx';

function OverflowChip({ size, count, names }) {
  const [hover, setHover] = useState(false);

  return (
    <span
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      style={{ position: 'relative', display: 'inline-flex', marginLeft: -8 }}
    >
      <span
        className="inline-flex items-center justify-center rounded-full"
        style={{
          width: size, height: size,
          background: '#F2F1ED', color: '#6B6B68',
          fontSize: Math.round(size * 0.4),
          border: '1.5px solid #fff',
          boxSizing: 'content-box'
        }}
      >
        +{count}
      </span>
      {hover && names.length > 0 && (
        <span
          role="tooltip"
          style={{
            position: 'absolute',
            bottom: 'calc(100% + 6px)',
            left: '50%',
            transform: 'translateX(-50%)',
            background: '#1A1A1A',
            color: '#fff',
            fontSize: 11,
            fontWeight: 500,
            lineHeight: 1.4,
            padding: '6px 10px',
            borderRadius: 4,
            whiteSpace: 'nowrap',
            pointerEvents: 'none',
            zIndex: 20,
            boxShadow: '0 2px 6px rgba(0,0,0,0.18)'
          }}
        >
          {names.map((n, i) => (
            <span key={i} style={{ display: 'block' }}>{n}</span>
          ))}
        </span>
      )}
    </span>
  );
}

export default function AvatarStack({ engineers = [], max = 5, size = 22 }) {
  const visible    = engineers.slice(0, max);
  const overflow   = engineers.slice(max);
  const overflowed = overflow.map(e => e.name || '?');

  return (
    <span className="inline-flex items-center">
      {visible.map((e, i) => (
        <span key={e.id || i} style={{ marginLeft: i === 0 ? 0 : -8 }}>
          <PersonLink redmineId={e.id} className="inline-flex">
            <Avatar initials={e.initials} seed={e.name || e.id} size={size} title={e.name} />
          </PersonLink>
        </span>
      ))}
      {overflow.length > 0 && (
        <OverflowChip size={size} count={overflow.length} names={overflowed} />
      )}
    </span>
  );
}
